<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/45ErwX/tc-custom/9781439670781.jpg?1702529458762" alt="This image is the cover for the book Fort Clinch, Fernandina and the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fort Clinch, Fernandina and the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Even though Fernandina was tucked away in the far southern reaches of the Confederacy, Fort Clinch had been abandoned to Federal forces by March 1862. It proved a boon to the Union war effort, and the island became a haven for runaway slaves, with many joining the Federal army. The military occupation of this vital seaport helped end the war, and the Reconstruction period that followed bore witness to Union and Confederate veterans working together to bring Fernandina into a golden era of prosperity. Author and local historian Frank A. Ofeldt III captures the vital and under-told story of Amelia Island during the Civil War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank A. Ofeldt III
      </h2>
      
      <p class="authorDescription body article">Frank A. Ofeldt III began as a volunteer with the Florida Park Service in the late 1980s as a historical interpreter in the Fort Clinch living history program. After college, he accepted a position with the agency and was assigned to Fort Taylor State Historic site at Key West, Florida, later transferring to Fort Clinch State Park, where he currently serves as a park service specialist, having served twenty-seven years with the agency. He is a published author of two books with Arcadia Publishing and The History Press. He continues to serve the community of Fernandina Beach as a local historian on military history of the island, was president of the Duncan Lamont Clinch Historical Society, former board member of the Amelia Island Museum of History and is member of the American Historical Association, Society for Military History and Council on America's Military Past. He is avid reader, lecturer and collector of American military antiques.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f5ac245